import type { Archive } from "../../domain/types";
import {
  resolveEmbeddingRoute,
  type FeatureRoutingSettings,
} from "../featureRoutes";
import { gatherRagContext } from "../../features/text-optimization-rag/service";
import { memoryContext } from "../../features/narrative-memory/service";
import { selectWorldGuidance } from "../../features/world-guidance/rules";
export async function gatherContext(
  archive: Archive,
  input: string,
  settings: FeatureRoutingSettings,
  signal?: AbortSignal,
) {
  const [rag, memory, guidance] = await Promise.all([
    gatherRagContext(input, resolveEmbeddingRoute(settings), signal).catch(
      () => "",
    ),
    Promise.resolve(memoryContext(archive, input)),
    Promise.resolve(selectWorldGuidance(input)),
  ]);
  return { rag, memory, guidance };
}
